// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import dataV from "@jiaminghi/data-view";
import "./adapterjs/media_750";
import { parseTime } from "@/untils/tool";
import { setStore, getStore, removeStore } from "@/untils/storage"; //缓存
// import "../src/assets/fonts/SOURCEHANSANSCN-BOLD.OTF";
// import "../src/assets/fonts/SOURCEHANSANSCN-REGULAR.OTF";

Vue.use(dataV);
Vue.use(ElementUI);
Vue.use(router); // 引入路由

Vue.config.productionTip = false;
Vue.prototype.setStore = setStore;
Vue.prototype.getStore = getStore;
Vue.prototype.removeStore = removeStore;
Vue.prototype.parseTime = parseTime;

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js